module.exports = __webpack_public_path__ + "img/img@2x.6a960180.webp";